import React from 'react';
import classNames from 'classnames'
import style from './App.less';
import { injectIntl } from 'react-intl';
class PrivacyGDPR extends React.PureComponent {
    state = {
        showloading: true
    }
    componentDidMount() {
        const { intl } = this.props;
        // if(intl.location)
        const lang = intl.locale.substring(0, 2)
        setTimeout(() => {
            this.setState({
                showloading: false
            })
        }, 400)
        document.title =  "Privacy Policy";
    }
    render() {
        const { intl } = this.props;

        const lang = intl.locale.substring(0, 2)
        console.log(lang, '===intl', intl.locale)
        return (
            <React.Fragment>
                {
                    (lang == "tr") &&
                    <div className={style.gdprBox}>
                        {this.state.showloading && <div className={style.white}></div>}
                        <p style={{ textAlign: "left" }}>{intl.formatMessage({ id: 'title' })}</p>
                        <p>{intl.formatMessage({ id: 'overview' })}</p>
                        <p>{intl.formatMessage({ id: 'overviewText1' })}</p>
                        <br />
                        <p>{intl.formatMessage({ id: 'overviewText2' })}</p>

                        <h3>{intl.formatMessage({ id: 'title1' })}</h3>
                        <p> {intl.formatMessage({ id: 'p0' })}</p>
                        <ul>
                            <li className={style.listed}>{intl.formatMessage({ id: 'li1' })}</li>
                            <p>{intl.formatMessage({ id: 'p1' })}</p>
                            <li className={style.listed}>{intl.formatMessage({ id: 'li2' })}</li>
                            <p>{intl.formatMessage({ id: 'p2' })}</p>
                            <li className={style.listed}>{intl.formatMessage({ id: 'li3' })}</li>
                            <p>{intl.formatMessage({ id: 'p3' })}</p>
                            <li className={style.listed}>{intl.formatMessage({ id: 'li4' })}</li>
                            <p>{intl.formatMessage({ id: 'p4' })}</p>
                        </ul>

                        <h3>{intl.formatMessage({ id: 'title2' })}</h3>
                        <ul>
                            <p>{intl.formatMessage({ id: 'p21' })}</p>
                            <p>{intl.formatMessage({ id: 'p22' })}</p>
                            <p>{intl.formatMessage({ id: 'p23' })}</p>
                        </ul>

                        <h3>{intl.formatMessage({ id: 'title3' })}</h3>
                        <ul>
                            <p>{intl.formatMessage({ id: 'p31' })}</p>
                            <p>{intl.formatMessage({ id: 'p32' })}</p>
                            <p>{intl.formatMessage({ id: 'p33' })}</p>
                        </ul>
                    </div >
                }
                {
                    (lang !== "tr") &&
                    <div className={classNames({ [style.gdprBox]: true, [style.enStyle]: true })}>
                        {this.state.showloading && <div className={style.white}></div>}
                        <h3>{intl.formatMessage({ id: 'title' })}</h3>
                        <p>{intl.formatMessage({ id: 'overview' })}</p>
                        <h4>- <span>{intl.formatMessage({ id: 'overviewText1' })}</span></h4>
                        <h4>- <span>{intl.formatMessage({ id: 'overviewText2' })}</span></h4>

                        <h3>{intl.formatMessage({ id: 'title1' })}</h3>
                        <p> {intl.formatMessage({ id: 'p0' })}</p>
                        <ul>
                            <li className={style.listed}><span>{intl.formatMessage({ id: 'li1' })}</span>{intl.formatMessage({ id: 'p1' })}</li>
                            <li className={style.listed}><span>{intl.formatMessage({ id: 'li2' })}</span>{intl.formatMessage({ id: 'p2' })}</li>
                            <li className={style.listed}><span>{intl.formatMessage({ id: 'li3' })}</span>{intl.formatMessage({ id: 'p3' })}</li>
                            <li className={style.listed}><span>{intl.formatMessage({ id: 'li4' })}</span>{intl.formatMessage({ id: 'p4' })}</li>
                        </ul>

                        <h3>{intl.formatMessage({ id: 'title2' })}</h3>
                        <ul>
                            <p>{intl.formatMessage({ id: 'p21' })}</p>
                            <p><span>{intl.formatMessage({ id: 'p22' })}</span>{intl.formatMessage({ id: 'p23' })}</p>
                            <p>{intl.formatMessage({ id: 'p24' })}</p>
                            <p>{intl.formatMessage({ id: 'p25' })}</p>
                            <p>{intl.formatMessage({ id: 'p26' })}</p>
                        </ul>

                        <h3>{intl.formatMessage({ id: 'title3' })}</h3>
                        <ul>
                            <p>{intl.formatMessage({ id: 'p31' })}</p>
                            <p>{intl.formatMessage({ id: 'p32' })}</p>
                            <p>{intl.formatMessage({ id: 'p33' })}</p>
                        </ul>

                        <h3>{intl.formatMessage({ id: 'title4' })}</h3>
                        <ul>
                            <p>{intl.formatMessage({ id: 'p41' })}</p>
                            <p>{intl.formatMessage({ id: 'p42' })}</p>
                            <p>{intl.formatMessage({ id: 'p43' })}</p>
                            <p>{intl.formatMessage({ id: 'p44' })}</p>
                            <p>{intl.formatMessage({ id: 'p45' })}</p>
                        </ul>

                        <h3>{intl.formatMessage({ id: 'title5' })}</h3>
                        <ul>
                            <p>{intl.formatMessage({ id: 'p51' })}</p>
                            <p>{intl.formatMessage({ id: 'p52' })}</p>
                        </ul>

                        <h3>{intl.formatMessage({ id: 'title6' })}</h3>
                        <ul>
                            <p>{intl.formatMessage({ id: 'p61' })}</p>
                            <p>{intl.formatMessage({ id: 'p62' })}</p>
                            <p>{intl.formatMessage({ id: 'p63' })}</p>
                        </ul>

                        <h3>{intl.formatMessage({ id: 'title7' })}</h3>
                        <ul>
                            <p>{intl.formatMessage({ id: 'p71' })}</p>
                            <p>{intl.formatMessage({ id: 'p72' })}</p>
                            <p>{intl.formatMessage({ id: 'p73' })}</p>
                            <p>{intl.formatMessage({ id: 'p74' })}</p>
                        </ul>

                        <h3>{intl.formatMessage({ id: 'title8' })}</h3>
                        <ul>
                            <p>{intl.formatMessage({ id: 'p81' })}</p>
                        </ul>

                        <h3>{intl.formatMessage({ id: 'title9' })}</h3>
                        <ul>
                            <p>{intl.formatMessage({ id: 'p91' })}</p>
                        </ul>

                        <h3>{intl.formatMessage({ id: 'title10' })}</h3>
                        <ul className={style.lastP}>
                            <p>{intl.formatMessage({ id: 'p101' })}</p>
                            <div>{intl.formatMessage({ id: 'p102' })}<span>{intl.formatMessage({ id: 'p103' })}</span>{intl.formatMessage({ id: 'p104' })}
                                <a>{intl.formatMessage({ id: 'p105' })}</a>
                                <p>
                                    {intl.formatMessage({ id: 'p106' })}<span>{intl.formatMessage({ id: 'p107' })}</span>
                                    {intl.formatMessage({ id: 'p108' })}
                                    <a>{intl.formatMessage({ id: 'p109' })}</a>
                                </p>
                                <p>
                                    {intl.formatMessage({ id: 'p110' })}
                                    <span>{intl.formatMessage({ id: 'p111' })}</span>
                                    {intl.formatMessage({ id: 'p112' })}
                                    <a>{intl.formatMessage({ id: 'p113' })}</a>
                                </p>
                            </div>
                            <br />
                            <br />
                        </ul>
                    </div >
                }
            </React.Fragment>
        )
    }
}
export default injectIntl(PrivacyGDPR);